import useDeliverLastOld from '@hypatia/react-hooks/useDeliverLastOld'
import screenOrientation$ from '@hypatia/utils/window/screenOrientation$'

export default function useScreenOrientation() {
    const { value } = useDeliverLastOld(screenOrientation$)
    return value!
}
